// @ts-check
import { css, jsx } from '@emotion/core';
import { Pagination } from 'antd';
import React from 'react';

import { bp } from '@/styles';
import { convertMomentToDate } from '@/utils/dateTimeHelpers';

import WhitepaperAttachmentCard from './WhitepaperAttachmentCard';

const style = {
  cardContainer: css`
    display: grid;
    gap: 1.6rem;
    grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  `
};

/**
 * @param {{
 *   results: import("../../../types").MediaLibraryItem[];
 *   handlePaginationChange?: import("antd/lib/pagination").PaginationProps['onChange'];
 *   current?: number;
 *   pageSize?: number;
 * }} props
 */
export default function WhitepaperAttachments(props) {
  const { results, handlePaginationChange = () => {}, current = 1, pageSize = 10 } = props;

  const filteredResults = (results ?? []).slice((current - 1) * pageSize, current * pageSize);

  return (
    <>
      <div css={style.cardContainer}>
        {filteredResults.map(item => (
          <WhitepaperAttachmentCard
            key={item.AttachmentId}
            title={item.FileTitle ? item.FileTitle : item.FileName}
            date={convertMomentToDate(item.PublishDate ? item.PublishDate : item.DateCreated)}
            buttonText="Download"
            buttonUrl={item.Url}
            tags={item.Tags}
            memberAccessLevels={item.MemberAccessLevels}
          />
        ))}
      </div>
      {results.length > pageSize && (
        <Pagination
          total={results.length}
          style={{ marginTop: '1.6rem', display: 'flex', justifyContent: 'flex-end' }}
          pageSize={pageSize}
          onChange={handlePaginationChange}
          showTotal={(total, range) => `Results ${range[0]}-${range[1]} of ${total} items`}
          current={current}
        />
      )}
    </>
  );
};